const FormResources = {

    form_data:{
        associate_id:                   '',
        supervisor_associate_id:        '',
        shift_id:                       '',
        group_id:                       '',
        cost_center_department_id:      '',
        number_assigment:               '',
        description:                    '',
        associate_pager:                '',
        supervisor_pager:               '',
        days_per_week:                  0,
        census:                         false,
        minutes:                        0,
        notes:                          '',
        avg_time_day:                   '',
        total_time:                     '',
        available_time:                 '',
        building_id:                    '',
        area_id:                        '',
        task_id:                        '',
        room_type_id:                   '',
        floor_id:                       '',
        cost_center_id:                 '',
        closed:                           '',
        work_group:                     '',
        exclude_project:                '',
        exclude_daily:                  '',
        policing:                       '',
        project:                        '',
        patient:                        '',
        freq_simbol:                    '',
        frequency:                      '',
        shift1:                         false,
        shift2:                         false,
        shift3:                         false,
        day_id: [],
        images: [],
        new_assignment_room_images: [],
    },

    form_data_search:
    {
        room: '',
        task: '',
        essential_cleaning: '',
        show_rooms_that_are: '',
        closed: '',
    },

    form_data_move: {
        current_daily_assignment_id: '',
        daily_assignment_id: '',
        for_today_only: false,
        hours: 12,
        rooms: []
    },

    form_data_note: {
        title: '',
        body_text: [],
        all_assignments: false,
        daily_assignment_id: [],
    },

    form_data_duty_note: {
        note: '',
        order: '',
        minutes: '',
        include_in_statuses: false,
        daily_assignments: [],
        days: []
    },
    
    week_form_data: {
        sunday:     false,
        monday:     false,
        tuesday:    false,
        wednesday:  false,
        thursday:   false,
        friday:     false,
        saturday:   false,
    },

    form_data_main_search:
    {
        daily_assignment_id: [],
        supervisor_id: [],
        shift_id: [],
    },

    form_format_main_search:
    [
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select assignment(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_id',
            ref:        'supervisor_id_input',
            ref_alt:    'supervisor_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select supervisor(s)',
            close_on_option: false,
            track_by: 'associate_name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select shift(s)',
            close_on_option: false,
            track_by: 'name'
        },

    ],

    form_format:[
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Assignment #:',
            model_name: 'number_assigment',
            ref:        'number_assigment_input',
            ref_alt:    'number_assigment_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  55,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Avg. Time/Day:',
            model_name: 'avg_time_day',
            ref:        'avg_time_day_input',
            ref_alt:    'avg_time_day_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Total Time:',
            model_name: 'total_minutes',
            ref:        'total_minutes_input',
            ref_alt:    'total_minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label:      'associate_name',
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_associate_id',
            ref:        'supervisor_associate_id_input',
            ref_alt:    'supervisor_associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate pager:',
            model_name: 'associate_pager',
            ref:        'associate_pager_input',
            ref_alt:    'associate_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor pager:',
            model_name: 'supervisor_pager',
            ref:        'supervisor_pager_input',
            ref_alt:    'supervisor_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  7,
            disabled:   false,
            step:       'any',
            name:       'Days per week:',
            model_name: 'days_per_week',
            ref:        'days_per_week_input',
            ref_alt:    'days_per_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-3',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Available Minutes:',
            model_name: 'total_shift_work_time',
            ref:        'available_time_input',
            ref_alt:    'available_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Minutes/Discharge:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work Days:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name',
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include in census:',
            model_name: 'census',
            ref:        'census_input',
            ref_alt:    'census_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  5000,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
        {
            css_class:          'col-md-6',
            type:               'file',
            maxlength:          5000,
            disabled:           false,
            step:               '',
            name:               'Images:',
            model_name:         'new_assignment_room_images',
            second_model_name:  'assignment_room_images',
            ref:                'new_assignment_room_images_input',
            ref_alt:            'new_assignment_room_images_input_alt',
            required:           false,
            multiple:           'multiple',
            style: 'right: 0px !important;'
        },
    ],

    form_format_modal:[
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Assignment #:',
            model_name: 'number_assigment',
            ref:        'number_assigment_input',
            ref_alt:    'number_assigment_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  55,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Avg. Time/Day:',
            model_name: 'avg_time_day',
            ref:        'avg_time_day_input',
            ref_alt:    'avg_time_day_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Total Time:',
            model_name: 'total_minutes',
            ref:        'total_time_input',
            ref_alt:    'total_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label:      'associate_name'
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_associate_id',
            ref:        'supervisor_associate_id_input',
            ref_alt:    'supervisor_associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate pager:',
            model_name: 'associate_pager',
            ref:        'associate_pager_input',
            ref_alt:    'associate_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor pager:',
            model_name: 'supervisor_pager',
            ref:        'supervisor_pager_input',
            ref_alt:    'supervisor_pager_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  7,
            disabled:   false,
            step:       'any',
            name:       'Days per week:',
            model_name: 'days_per_week',
            ref:        'days_per_week_input',
            ref_alt:    'days_per_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       'any',
            name:       'Available Minutes:',
            model_name: 'total_shift_work_time',
            ref:        'available_time_input',
            ref_alt:    'available_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Minutes/Discharge:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work Days:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include in census:',
            model_name: 'census',
            ref:        'census_input',
            ref_alt:    'census_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  5000,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
        {
            css_class:          'col-md-6',
            type:               'file',
            maxlength:          5000,
            disabled:           false,
            step:               '',
            name:               'Images:',
            model_name:         'new_assignment_room_images',
            second_model_name:  'assignment_room_images',
            ref:                'new_assignment_room_images_input',
            ref_alt:            'new_assignment_room_images_input_alt',
            required:           false,
            multiple:           'multiple',
            style: 'right: 0px !important;'
        },
    ],


    form_format_move:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Assigment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'For today only:',
            model_name: 'for_today_only',
            ref:        'for_today_only_input',
            ref_alt:    'for_today_only_input_alt',
            required:   false,
        },
    ],

    form_format_copy:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Assigment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   true,
        },
    ],

    form_format_note:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Content:',
            model_name: 'body_text',
            ref:        'body_text_input',
            ref_alt:    'body_text_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'All Assignments:',
            model_name: 'all_assignments',
            ref:        'all_assignments_input',
            ref_alt:    'all_assignments_input_alt',
            required:   false,
        },
    ],

    shift_options:  [
        {
            id:     1,
            name:   'Day',
        },
        {
            id:     2,
            name:   'Evening',
        },
        {
            id:     3,
            name:   'Night',
        },
    ],

    days:  [
        {
            id:      7,
            name:   'Sun',
        },
        {
            id:     1,
            name:   'Mon',
        },
        {
            id:     2,
            name:   'Tue',
        },
        {
            id:     3,
            name:   'Wed',
        },
        {
            id:     4,
            name:   'Thur',
        },
        {
            id:     5,
            name:   'Fri',
        },
        {
            id:     6,
            name:   'Sat',
        },
    ],

    days_per_weeks:  [
        {
            id:     0,
        },
        {
            id:     1,
        },
        {
            id:     2,
        },
        {
            id:     3,
        },
        {
            id:     4,
        },
        {
            id:     5,
        },
        {
            id:     6,
        },
        {
            id:     7,
        },
    ],

}

export default FormResources;